if (!customElements.get('wepack-sticky-usps')) {
  customElements.define('wepack-sticky-usps', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-usp]')];
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.timer = setInterval(() => {
        if (this.motion.matches || document.hidden || this.items.length < 2) return;
        this.items[this.index].classList.remove('is-active');
        this.fadeTimer = setTimeout(() => {
          this.index = (this.index + 1) % this.items.length;
          this.items[this.index].classList.add('is-active');
        }, 320);
      }, 5000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.fadeTimer);
    }
  });
}

(() => {
  const init = () => {
    const bar = document.querySelector('.sticky-cta');
    const btn = document.querySelector('.product-form__submit');
    if (!bar || !btn) return console.warn('sticky-cta: bar or inline button not found', { bar, btn });

    new IntersectionObserver(([e]) => {
      bar.toggleAttribute('data-past-inline', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(btn);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();